module.exports = __webpack_public_path__ + "static/media/history_7.e48b1dbf.jpg";